import { useMutation } from 'react-query'

import { request } from '../utils/api'
import { HTTPMethod } from '../utils/api.types'
import type { Response } from '../utils/api.types'

type CancelGuestRequestRequest = {
  live_id: string
  live_speaker_id: string
  presenter_token: string
  cancel_method: 'expire' | 'delete'
}

type CancelGuestRequestResponse = Response

type CancelGuestRequestData = {
  sessionId: CancelGuestRequestRequest['live_id']
  speakerId: CancelGuestRequestRequest['live_speaker_id']
  presenterToken: CancelGuestRequestRequest['presenter_token']
  cancelMethod?: CancelGuestRequestRequest['cancel_method']
}

type CancelGuestRequestMutationRequest = CancelGuestRequestData

function cancelGuestRequest(data: CancelGuestRequestData) {
  return request<CancelGuestRequestRequest, CancelGuestRequestResponse>({
    url: '/api/2/live/speaker/cancel-guest-request',
    method: HTTPMethod.POST,
    data: {
      live_id: data.sessionId,
      live_speaker_id: data.speakerId,
      presenter_token: data.presenterToken,
      cancel_method: data.cancelMethod || 'delete',
    },
  })
}

function useCancelGuestRequestMutation() {
  return useMutation<void, unknown, CancelGuestRequestMutationRequest>(
    async (data) => {
      await cancelGuestRequest(data)
    }
  )
}

export { cancelGuestRequest, useCancelGuestRequestMutation }
